<div class="cr" #crRoot>

  <!-- ==================================================================== -->
  <!-- HERO                                                                  -->
  <!-- ==================================================================== -->
  <section class="cr-hero" aria-labelledby="cr-hero-title">
    <div class="cr-hero__deco" aria-hidden="true">
      <span class="cr-blob cr-blob--1"></span>
      <span class="cr-blob cr-blob--2"></span>
      <span class="cr-dots cr-dots--1"></span>
      <span class="cr-dots cr-dots--2"></span>
      <span class="cr-spark" style="--x: 52%; --y: 14%; --d: 0s"></span>
      <span class="cr-spark" style="--x: 46%; --y: 68%; --d: 1.6s"></span>
      <span class="cr-spark" style="--x: 92%; --y: 8%; --d: 2.8s"></span>
    </div>

    <div class="cr-shell cr-hero__inner">
      <!-- ------------------------------------------------- left: copy ---- -->
      <div class="cr-hero__copy">
        <span class="cr-hero__eyebrow">Careers</span>

        <h1 class="cr-hero__title" id="cr-hero-title">
          Come, join us!<br />
          <span class="cr-grad">We’re hiring.</span>
        </h1>

        <p class="cr-hero__lede">
          We believe that each one of us should be able to find our dream job, and we
          constantly strive hard to make that possible. Apply now!
        </p>

        <ul class="cr-facts" aria-label="Why work here">
          <li class="cr-fact">
            <span class="cr-fact__ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 3l7 4v5c0 4.3-2.9 7.9-7 9-4.1-1.1-7-4.7-7-9V7l7-4z" stroke="currentColor"
                  stroke-width="1.8" stroke-linejoin="round" />
              </svg>
            </span>
            Stable, product-led work
          </li>
          <li class="cr-fact">
            <span class="cr-fact__ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.8" />
              </svg>
            </span>
            Full-time, on-site in Bilaspur
          </li>
          <li class="cr-fact">
            <span class="cr-fact__ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Mentored growth from day one
          </li>
        </ul>
      </div>

      <!-- ------------------------------------------ right: blob photo ---- -->
      <div class="cr-hero__art" aria-hidden="true">
        <span class="cr-hero__glow"></span>
        <div class="cr-hero__blob">
          <img loading="lazy" src="assets/images/team-building.jpg" alt="" />
        </div>
        <span class="cr-hero__grid-dots"></span>
        <span class="cr-hero__bracket cr-hero__bracket--tl"></span>
        <span class="cr-hero__bracket cr-hero__bracket--br"></span>
      </div>
    </div>
  </section>

  <!-- ==================================================================== -->
  <!-- OPEN ROLES                                                            -->
  <!-- ==================================================================== -->
  <section class="cr-roles" id="jobs" aria-labelledby="cr-roles-title">
    <div class="cr-shell">
      <header class="cr-head">
        <span class="cr-head__eyebrow">Open Roles</span>
        <h2 class="cr-head__title" id="cr-roles-title">
          Find Your <span class="cr-grad">Opportunity</span>
        </h2>
      </header>

      <div class="cr-roles__grid">
        <article class="cr-role" *ngFor="let role of roles">
          <span class="cr-role__tile" aria-hidden="true">
            <ng-container [ngSwitch]="role.icon">
              <!-- wordmark tiles -->
              <b class="cr-role__mark" *ngSwitchCase="'php'">{{ role.mark }}</b>
              <b class="cr-role__mark" *ngSwitchCase="'dotnet'">{{ role.mark }}</b>
              <b class="cr-role__mark cr-role__mark--sm" *ngSwitchCase="'dotnetcore'">{{ role.mark }}</b>

              <!-- glyph tiles -->
              <svg *ngSwitchCase="'react'" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="2.1" fill="currentColor" />
                <ellipse cx="12" cy="12" rx="9.5" ry="3.9" stroke="currentColor" stroke-width="1.4" />
                <ellipse cx="12" cy="12" rx="9.5" ry="3.9" stroke="currentColor" stroke-width="1.4"
                  transform="rotate(60 12 12)" />
                <ellipse cx="12" cy="12" rx="9.5" ry="3.9" stroke="currentColor" stroke-width="1.4"
                  transform="rotate(120 12 12)" />
              </svg>

              <svg *ngSwitchCase="'angular'" viewBox="0 0 24 24" fill="none">
                <path d="M12 2.6l9 3.2-1.4 12L12 21.4 4.4 17.8 3 5.8l9-3.2z" stroke="currentColor"
                  stroke-width="1.5" stroke-linejoin="round" />
                <path d="M8.6 15.4L12 7l3.4 8.4M9.8 13h4.4" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <svg *ngSwitchCase="'tester'" viewBox="0 0 24 24" fill="none">
                <path d="M9 4.5h6l-1 4.2a6.5 6.5 0 013.4 5.7A5.4 5.4 0 0112 20a5.4 5.4 0 01-5.4-5.6A6.5 6.5 0 0110 8.7L9 4.5z"
                  stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                <path d="M9.6 14.2l1.7 1.7 3.2-3.4" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <svg *ngSwitchCase="'designer'" viewBox="0 0 24 24" fill="none">
                <path d="M4 20l3.2-.7 11-11a2.1 2.1 0 00-3-3L4.3 16.3 4 20z" stroke="currentColor"
                  stroke-width="1.5" stroke-linejoin="round" />
                <path d="M14.4 5.9l3.1 3.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>

              <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none">
                <path d="M2.8 9.2L12 5l9.2 4.2L12 13.5 2.8 9.2z" stroke="currentColor" stroke-width="1.5"
                  stroke-linejoin="round" />
                <path d="M6.6 11v4.4c0 1.6 2.4 2.8 5.4 2.8s5.4-1.2 5.4-2.8V11M20 10.4v4"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </ng-container>
          </span>

          <div class="cr-role__body">
            <h3 class="cr-role__title">{{ role.title }}</h3>

            <ul class="cr-role__meta" aria-label="Role details">
              <li>
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7" />
                  <path d="M12 7.5V12l3.2 1.9" stroke="currentColor" stroke-width="1.7"
                    stroke-linecap="round" />
                </svg>{{ role.experience }}
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="3" y="7.5" width="18" height="12" rx="2.5" stroke="currentColor"
                    stroke-width="1.7" />
                  <path d="M9 7.5V6a2 2 0 012-2h2a2 2 0 012 2v1.5M3 12h18" stroke="currentColor"
                    stroke-width="1.7" stroke-linecap="round" />
                </svg>{{ role.type }}
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 21s7-5.4 7-10.4A7 7 0 005 10.6C5 15.6 12 21 12 21z" stroke="currentColor"
                    stroke-width="1.7" stroke-linejoin="round" />
                  <circle cx="12" cy="10.4" r="2.4" stroke="currentColor" stroke-width="1.7" />
                </svg>{{ role.location }}
              </li>
            </ul>

            <p class="cr-role__desc">{{ role.description }}</p>

            <div class="cr-role__apply">
              <app-contact-btn-modal [post]="role.post" id="applynow"></app-contact-btn-modal>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- ==================================================================== -->
  <!-- WHY RESILIENCESOFT                                                    -->
  <!-- ==================================================================== -->
  <section class="cr-perks" aria-labelledby="cr-perks-title">
    <div class="cr-perks__deco" aria-hidden="true">
      <span class="cr-blob cr-blob--3"></span>
    </div>

    <div class="cr-shell">
      <header class="cr-head">
        <span class="cr-head__eyebrow">Why ResilienceSoft?</span>
        <h2 class="cr-head__title" id="cr-perks-title">
          More Than <span class="cr-grad">Just a Job</span>
        </h2>
      </header>

      <div class="cr-perks__grid">
        <article class="cr-perk" *ngFor="let perk of perks">
          <span class="cr-perk__ico" aria-hidden="true">
            <ng-container [ngSwitch]="perk.icon">
              <svg *ngSwitchCase="'growth'" viewBox="0 0 24 24" fill="none">
                <path d="M4 17l5-5 4 3 7-8" stroke="currentColor" stroke-width="1.9"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16 7h4v4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <svg *ngSwitchCase="'culture'" viewBox="0 0 24 24" fill="none">
                <circle cx="9" cy="8.5" r="3.1" stroke="currentColor" stroke-width="1.8" />
                <path d="M3.4 19c0-3.1 2.5-5.2 5.6-5.2s5.6 2.1 5.6 5.2M16 6.2a3.1 3.1 0 010 5.9M17.4 19c0-2.3-.8-3.9-2.2-4.8"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
              <svg *ngSwitchCase="'projects'" viewBox="0 0 24 24" fill="none">
                <path d="M12 3a6 6 0 00-3.4 10.9c.5.4.8 1 .8 1.6v.5h5.2v-.5c0-.6.3-1.2.8-1.6A6 6 0 0012 3z"
                  stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                <path d="M10 19.5h4M10.6 21.5h2.8" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" />
              </svg>
              <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.8" />
                <path d="M12 7.4V12l3.4 2" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" />
              </svg>
            </ng-container>
          </span>
          <h3 class="cr-perk__title">{{ perk.title }}</h3>
          <p class="cr-perk__text">{{ perk.text }}</p>
        </article>
      </div>
    </div>
  </section>

  <!-- Legacy apply dialog markup, preserved from the original page. It has no
       trigger of its own — the "Apply Now" buttons open the Material dialog. -->
  <div id="popup1" class="modal fade">
    <div class="popup">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">&times;</button>
      <div class="popup__grid">
        <div class="popup__media">
          <img loading="lazy" src="/assets/images/job-apply.jpg" alt="job">
        </div>
        <div class="popup__form">
          <div class="sidebar">
            <div class="block clearfix">
              <h3 class="ab_sec_heading-pop"><b>Submit Your Details</b></h3>
              <form class="my_detail" method="post" enctype="multipart/form-data">
                <div class="form-group">
                  <label for="name">Full Name</label>
                  <input type="email" class="form-control-job user_icon" id="name"
                    (keypress)="onSpace($event)" />
                </div>
                <div class="form-group">
                  <label for="mail">Email</label>
                  <input type="email" class="form-control-job mail_icon" id="mail" />
                </div>
                <div class="form-group">
                  <label for="Number">Phone Number</label>
                  <input type="text" class="form-control-job user_icon" id="Number" />
                </div>
                <div class="form-group">
                  <label for="file_1">Upload Resume (*.doc,*docx,*.pdf)</label>
                  <input type="file" id="file_1" name="file_1" required="required"
                    class="form-control-job user_icon">
                </div>
                <div class="alert alert-success" id="success" style="display: none;"></div>
                <div class="alert alert-danger" id="failed" style="display: none;"></div>
                <input type="submit" value="Submit" class="submit-button">
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
